import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import { horizontalChildSpacing } from 'components/utils/spacing'
import SelectTourType from 'tripPlanner/components/TripModal/TripItems/Variety/SelectTourType'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

type Props = {
  tripId: string
  beforeClick?: () => void
}

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${rem(24)};
  width: 100%;

  ${horizontalChildSpacing[16]}
`

function TourCTA({ tripId, beforeClick }: Props) {
  const openModal = useOpenModal()
  return (
    <Buttons>
      <TextButton
        kind="primary"
        onClick={() => {
          beforeClick?.()
          openModal(SelectTourType, {
            tripId,
          })
        }}
      >
        Search tours
      </TextButton>
      <TextButton
        kind="secondary"
        onClick={() => {
          beforeClick?.()
          openModal(SelectTourType, {
            tripId,
          })
        }}
      >
        Add your own
      </TextButton>
    </Buttons>
  )
}

export default TourCTA
